$('.review_slider').slick({
  infinite: true,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1
});

jQuery(".faq_box h5").first().addClass("show");
jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
else
{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});

if($(window).width() <= '749'){
  $('.col_list').slick({
    infinite: true,
    dots: true,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}

if($(window).width() <= '989'){
  $('.logo_list').slick({
    infinite: true,
    dots: true,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
}
$(document).ready(function() {
  $('.image-popup-fit-width').magnificPopup({type:'image'});
});
                
// // JavaScript function to toggle content based on height
// function toggleTextOnLoad() {
//   const descriptionDiv = document.querySelector('.collection-description');
//   const maxHeight = 77; // Adjust this value to your preferred maximum height

//   if (descriptionDiv.scrollHeight > maxHeight) {
//       descriptionDiv.style.height = maxHeight + 'px';

//       const moreText = document.createElement('span');
//       moreText.className = 'more-text';
//       moreText.textContent = ' Read more...';

//       moreText.addEventListener('click', function () {
//           if (descriptionDiv.style.height === maxHeight + 'px') {
//               descriptionDiv.style.height = 'auto';
//               moreText.textContent = ' Read less...';
//           } else {
//               descriptionDiv.style.height = maxHeight + 'px';
//               moreText.textContent = ' Read more...';
//           }
//       });

//       // Add the "Read more" link after .collection-description
//       descriptionDiv.parentNode.insertBefore(moreText, descriptionDiv.nextSibling);
//   }
// }

// // Call the toggleTextOnLoad function when the page loads
// window.addEventListener('load', toggleTextOnLoad);


   /*---------------- Responsive Footer Menu ------------------*/
  $('.footer-block__heading').on("click", function(e) {
    if ($(this).hasClass('menushow')) {
      remove_styles();
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    } else {
      remove_styles();
      $(this).addClass('menushow');
      $(this).next('ul').addClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').addClass('menushowtoggle');
      }
    }
    e.stopPropagation();
    e.preventDefault();
  });

  function remove_styles() {
    $('.footer-block__heading').each(function() {
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    });
  }

  /*---------------- Responsive Footer Menu end ------------------*/
